import * as _ from 'lodash';

export const updateActionStatuses = (statuses: any, actions: any): void => {
  _.forEach(actions, (action: any) => {
    action.active = statuses[action.action] ? statuses[action.action] : false;
  });
};
